export default __webpack_public_path__ + "static/media/img-error-bg.a65a157a.svg";